import { useMutation, useQuery } from '@tanstack/react-query';
import { useAuthUser } from '~/contexts/Auth/AuthContext';
import { useAccount } from '~/contexts/UserAccount/UserAccountContext';
import { EcmsPortal } from './types';
import { useTaxExemptionsRepository } from './rest';

export const useTaxExemption = () => {
    const { getTaxExemptionsInfo } = useTaxExemptionsRepository();
    const currentAccount = useAccount();

    return useQuery({
        queryKey: ['tax-exemption', currentAccount.id],
        queryFn: () => getTaxExemptionsInfo(currentAccount.id),
    });
};

export const useTaxExemptionPortal = () => {
    const { getTaxExemptionPortal } = useTaxExemptionsRepository();
    const currentAccount = useAccount();

    return useQuery({
        queryKey: ['tax-exemption-portal', currentAccount.id],
        queryFn: () => getTaxExemptionPortal(currentAccount.id),
    });
};

export const useCreateTaxExemptionPortal = () => {
    const user = useAuthUser();
    const { createTaxExemptionPortal } = useTaxExemptionsRepository();
    const currentAccount = useAccount();

    return useMutation<EcmsPortal>({
        mutationKey: ['create-tax-exemption-portal'],
        mutationFn: () => createTaxExemptionPortal(currentAccount.id, user.email),
    });
};
